import type { StorageAdapter } from './storage-adapter';

/**
 * Adapter over a browser `Storage` handed in by the caller: this layer cannot use the global
 * localStorage (GDD §15.2). Methods may throw (SecurityError, QuotaExceededError); see storage.ts.
 */
export function createLocalStorageAdapter(storage: Storage): StorageAdapter {
  return {
    get: (key) => storage.getItem(key),
    set: (key, value) => storage.setItem(key, value),
    remove: (key) => storage.removeItem(key),
  };
}
